import { jsx } from "react/jsx-runtime";
import { cn } from "../v2/utils.js";
const Count = ({ count, 'data-testid': dataTestId, selected, disabled, styleSelectAround })=>/*#__PURE__*/ jsx("div", {
        className: cn(' tw-ml-1 tw-px-0.8 tw-rounded-0.4', selected ? 'tw-bg-primary-light-200 dark:tw-bg-secondary-light-200' : 'tw-bg-neutral-light-400 dark:tw-bg-neutral-dark-600', {
            '!tw-bg-neutral-light-100': styleSelectAround && selected
        }),
        "data-testid": dataTestId,
        children: /*#__PURE__*/ jsx("span", {
            className: cn({
                'dark:tw-text-neutral-light-800': disabled,
                'tw-text-neutral-light-800': styleSelectAround && !selected,
                'dark:tw-text-elevation-dark-00': selected
            }),
            children: count
        })
    });
const Tab_Count = Count;
export default Tab_Count;
